import PropTypes from 'prop-types';
import { Link as RouterLink } from 'react-router-dom';

import Chip from '@zenbusiness/zui/Chip';
import Stack from '@zenbusiness/zui/Stack';

import { PRODUCTS_FILTER_PARAM_KEY } from '#client/pages/Home/ProductCards/constants';

function CategoryPill({ categories }) {
  if (!categories || !categories.length) {
    return null;
  }

  return (
    <Stack
      gap={0.5}
      horizontal
      sx={{
        pointerEvents: 'none',
        zIndex: 1
      }}
    >
      {categories.map((category) => (
        <Chip
          sx={{ pointerEvents: 'all' }}
          clickable
          component={RouterLink}
          key={category.state}
          size="sm"
          to={`?${PRODUCTS_FILTER_PARAM_KEY}=${category.state}`}
        >
          {category.label}
        </Chip>
      ))}
    </Stack>
  );
}

CategoryPill.propTypes = {
  categories: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      state: PropTypes.string
    })
  )
};

export default CategoryPill;
